import React from 'react';
import DashboardMessage from './DashboardMessage';
import './DashboardEmpty.css';

export const DashboardEmpty = () => (
  <div className="row main align-items-center">
    <DashboardMessage>
      <div className="claperboard-film mb-5" />
    </DashboardMessage>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/DashboardMain/DashboardEmpty.js